angular.
module("dx.webapp.class").
component("dxClassAddSingleStudent", {
	templateUrl: "tmpl/class/class-add-single-student-component.html",
	controller: "DxClassAddSingleStudentController",
	controllerAs: "vm",
	bindings: {
		classId: "=",
		loadClassCallback: "=",
		liveView: "=",
		disabledStudentcodes: "<",
	},
});
